import React, {  useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { FormikHandlers, FormikErrors, FormikTouched } from 'formik';

import { MarketingInput, ImageUploader } from '../../../common/components';
import { distances } from '../../../../styles/constants';
import { DiscountItem, Campaign, AssetRequestObject } from '../../../types';
import { validateNested } from '../../helpers';

interface LoyaltyCardProps {
    discount: DiscountItem;
    index: number;
    createAsset: (asset: AssetRequestObject) => void;
    removeAsset: (discountId: string) => void;
    handleChange: FormikHandlers['handleChange'];
    handleBlur: FormikHandlers['handleBlur'];
    errors: FormikErrors<Campaign>;
    touched: FormikTouched<Campaign>;
    asset?: string;
}

const clipStyleOptions = [
    {
        label: 'Circles',
        value: 'circles',
    },
    {
        label: 'Stars',
        value: 'stars',
    },
    {
        label: 'Diamonds',
        value: 'diamonds',
    },
    {
        label: 'Squares',
        value: 'squares',
    },
];

const LoyaltyCard = (
    {
        discount,
        index,
        createAsset,
        removeAsset,
        handleChange,
        handleBlur,
        errors,
        touched,
        asset,
    }: LoyaltyCardProps
) => {
    const { t } = useTranslation();
    const [clipStyle] = useState(clipStyleOptions[0]);

    const validate = validateNested(index, errors, touched);

    return (
        <>
            <DiscountDetailsWrapper>
                <DetailsInputWrapper>
                    <MarketingInput
                        type="text"
                        label={t('marketing.campaign.reward_title')}
                        labelOpacity={1}
                        placeholder=""
                        name={`discounts.${index}.title`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={discount.title}
                        validation={validate('title')}
                    />
                    <MarketingInput
                        type="textarea"
                        label={t('marketing.campaign.reward_description')}
                        labelOpacity={1}
                        placeholder=""
                        name={`discounts.${index}.description`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={discount.description}
                        validation={validate('description')}
                        isTextArea
                    />
                    {/* <MarketingDropdown
                        name='clipStyle'
                        value={clipStyle}
                        onChange={(option) => {
                            setClipStyle(option);
                        }}
                        options={clipStyleOptions}
                    /> */}
                    <MarketingInput
                        type="textarea"
                        label={t('marketing.campaign.add_webshop_link')}
                        labelOpacity={1}
                        placeholder="https://example.com"
                        name={`discounts.${index}.webshop`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={discount.webshop || ''}
                        validation={validate('webshop')}
                    />
                </DetailsInputWrapper>
                <UploaderWrapper>
                    <ImageUploader
                        createAsset={createAsset}
                        discountId={discount.id}
                        // isLoyaltyCard
                        clipStyle={clipStyle.value}
                        removeAsset={removeAsset}
                        asset={asset}
                    />
                </UploaderWrapper>
            </DiscountDetailsWrapper>
            {/* <LoyaltyCardButton type='button'>
                <P>{t('marketing.campaign.design_loyalty_card')}</P>
            </LoyaltyCardButton> */}
        </>
    );
};

const DiscountDetailsWrapper = styled.div`
    display: flex;

    @media (max-width: 768px) {
        display: block;
        width: 100%;
    }
`;

const DetailsInputWrapper = styled.div`
    width: calc(50% - ${distances.tiny});
    margin-right: ${distances.tiny};

    @media (max-width: 768px) {
        width: 100%;
        margin-right: 0;
    }
`;

const UploaderWrapper = styled.div`
    height: 100%;
    width: calc(50% - ${distances.tiny});
    margin-left: ${distances.tiny};

    @media (max-width: 768px) {
        width: 100%;
        margin-left: 0;
    }
`;

// const LoyaltyCardButton = styled(Button as any)`
//     background-color: ${colors.backgroundAlt};
//     border-color: ${colors.backgroundAlt};
//     margin-top: ${distances.normal};

//     &:hover {
//         background-color: ${colors.interactiveBackgroundHover};
//         border-color: ${colors.interactiveBackgroundHover};
//     }
// `;

export default LoyaltyCard;
